import '../css/app.scss';
import { applyCsrfFromMeta } from './bootstrap';

import { createInertiaApp, router } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';

const appName = import.meta.env.VITE_APP_NAME || 'YoungVoices';
applyCsrfFromMeta(); // at boot

// IMPORTANT: refresh token header after every successful Inertia visit
router.on('success', (event) => {
    applyCsrfFromMeta();

    // Log Inertia shared props for debugging
    if (import.meta.env.DEV) {
        const page = event.detail.page;
        console.group(`[Inertia] ${page.component} — ${page.url}`);
        console.log('props:', page.props);
        console.log('auth:', page.props?.auth);
        if (page.props?.auth?.user?.teacher_banners) {
            console.log('teacher_banners:', page.props.auth.user.teacher_banners);
        }
        if (page.props?.flash) {
            const flash = page.props.flash;
            if (flash.message || flash.error || flash.success) {
                console.log('flash:', flash);
            }
        }
        console.groupEnd();
    }
});

createInertiaApp({
    title: title => `${title} - ${appName}`,
    resolve: name => resolvePageComponent(`./Pages/${name}.jsx`, import.meta.glob('./Pages/**/*.jsx')),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(<App {...props} />);
    },
    progress: {
        color: '#4B5563',
    },
});
